import styled from 'styled-components';
import { bookitColors } from 'styles/colors/bookitColors';
import clsx from 'clsx';

export interface BadgeCounterProps {
  count?: number;
}
const Badge = styled('div')(({ theme }) => ({
  '&.badgeRoot': {
    display: 'flex',
    width: '16px',
    height: '16px',
    //padding: '1.5px 0px 2px 0px',
    padding: 0,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '100px',
    background: bookitColors.grayscale.grayComponentsLight,
    '&.hasValue': {
      background: bookitColors.primary.components,
    },
    '& .badgeText': {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      flex: '1 0 0',
      alignSelf: 'stretch',
      color: bookitColors.base.white,
      textAlign: 'center',
      /* Bkt/Tips Regular */
      fontFamily: `'Lato', sans-serif`,
      fontSize: '10px',
      fontStyle: 'normal',
      lineHeight: '141%' /* 19.2px */,
      fontWeight: 400,
      letterSpacing: '0.2px',
    },
  },
}));
export function BadgeCounter(props: BadgeCounterProps) {
  return (
    <Badge
      className={clsx('badgeRoot', {
        hasValue: !!props.count && props.count > 0,
      })}
    >
      <span className="badgeText">{props.count ?? 0}</span>
    </Badge>
  );
}
